import type { Router } from 'vue-router'
import { createPermissionGuard } from './permissionGuard'

export function setupRouterGuard(router: Router) {
  createPermissionGuard(router)
  // createProgressGuard(router)
}

/** 路由切换进度条 */
export function createProgressGuard() {
  // NProgress.configure({ showSpinner: false, parent: '#app' })

  // router.beforeEach(() => {
  //   NProgress.start()
  // })

  // router.afterEach(() => {
  //   NProgress.done()
  // })
}
